import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'wok-panel-link';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    props: {
        icon: {
            type: String,
            default: undefined
        },
        title: {
            type: String,
            required: true
        },
        tooltip: {
            type: String,
            default: undefined
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'li', { class: ['wok--panel-link__wrapper', ctx.data.staticClass] }, [
                h(appropriateTag(ctx), { 
                    class: 'wok--panel-link',
                    attrs: { 
                        title: ctx.props.tooltip, 
                        ...ctx.data.attrs 
                    },
                    on: ctx.listeners
                }, [
                    ctx.props.icon && h('i', { class: 'wok--panel-link__icon' }, [
                        h(ctx.props.icon)
                    ]),
                    h('span', { class: 'wok--panel-link__title wok--heading-06' }, [
                        ctx.props.title
                    ])
                ])
            ]
        )
    }
}

function appropriateTag(ctx: RenderContext) {
    if (ctx.data.attrs && ctx.data.attrs.to) {
        return 'router-link';
    }
    if (ctx.data.attrs && ctx.data.attrs.href) {
        return 'a';
    }
    return 'button';
}